(function() {
  function initStickyCart() {
    const stickyBar = document.getElementById('sticky-add-to-cart');
    if (!stickyBar) return;

    // 1. Detección de Scroll: Solo debe aparecer cuando uno haya bajado de la información de producto
    const productInfo = document.querySelector('.product__info-container') ||
                        document.querySelector('.product__info-wrapper') ||
                        document.querySelector('product-info') ||
                        document.querySelector('.product');
    
    if (!productInfo) return;

    const checkScroll = () => {
      const rect = productInfo.getBoundingClientRect();
      // rect.bottom <= 20 significa que la sección de información del producto ha salido por arriba de la pantalla
      if (rect.bottom <= 20) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('resize', checkScroll, { passive: true });
    checkScroll();

    // 2. Variantes y elementos del Sticky Bar
    const variantsDataScript = stickyBar.querySelector('.sticky-cart-bar__variants-data');
    let variants = [];
    if (variantsDataScript) {
      try {
        variants = JSON.parse(variantsDataScript.textContent);
      } catch (e) {
        console.error('Error al parsear variantes del sticky cart:', e);
      }
    }

    const stickySelects = stickyBar.querySelectorAll('.sticky-cart-bar__select');
    const stickyButton = stickyBar.querySelector('.sticky-cart-bar__button');
    const stickyButtonText = stickyBar.querySelector('.sticky-cart-bar__button-text');
    const stickyPrice = stickyBar.querySelector('.sticky-cart-bar__price');
    const stickyImage = stickyBar.querySelector('.sticky-cart-bar__image-wrapper img');
    const defaultButtonText = (stickyButton && stickyButton.dataset.defaultText) || 'Agregar al carro';

    // Detección automática del formato de precio (pesos vs centavos, separador de miles y sufijo)
    let priceRatio = 1;
    let priceSeparator = ',';
    let priceSuffix = '';

    function setupPriceDetection(text, initialVariantPrice) {
      if (!text || !initialVariantPrice) return;
      const match = text.match(/\$\s*[\d.,]+/);
      if (match) {
        const digits = match[0].replace(/\D/g, '');
        if (digits) {
          const parsed = parseInt(digits, 10);
          if (parsed > 0 && initialVariantPrice % parsed === 0) {
            priceRatio = Math.round(initialVariantPrice / parsed);
          }
        }
        priceSeparator = match[0].includes('.') ? '.' : ',';
      }
      if (text.includes('CLP')) priceSuffix = ' CLP';
    }

    function formatPrice(raw) {
      if (raw == null) return '';
      let amount = Math.round(Number(raw) / (priceRatio || 1));
      const parts = Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, priceSeparator);
      return '$' + parts + priceSuffix;
    }

    function renderStickyPrice(variant) {
      if (!variant || !stickyPrice) return;
      const price = variant.price;
      const compareAt = variant.compare_at_price;
      const hasSale = compareAt && Number(compareAt) > Number(price);

      if (hasSale) {
        const discountPercent = Math.round(((Number(compareAt) - Number(price)) * 100) / Number(compareAt));
        stickyPrice.innerHTML = `
          <div class="price price--large price--on-sale">
            <div class="price__container">
              <div class="price__sale">
                <span class="price-item price-item--sale price-item--last">${formatPrice(price)}</span>
                <s class="price-item price-item--regular">${formatPrice(compareAt)}</s>
                <span class="discount-percentage">${discountPercent}% OFF</span>
              </div>
            </div>
          </div>
        `;
      } else {
        stickyPrice.innerHTML = `
          <div class="price price--large">
            <div class="price__container">
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatPrice(price)}</span>
              </div>
            </div>
          </div>
        `;
      }
    }

    // Obtener todas las opciones seleccionadas combinando la ficha principal (opciones ocultas como Modelo) con el sticky cart
    function getFullSelectedOptions() {
      const selected = {};

      const variantSelects = document.querySelector('variant-selects');
      if (variantSelects) {
        const checkedRadios = variantSelects.querySelectorAll('input[type="radio"]:checked');
        checkedRadios.forEach(radio => {
          const nameMatch = radio.name.match(/-(\d+)$/);
          if (nameMatch) {
            selected[`option${nameMatch[1]}`] = radio.value;
          }
        });

        const selects = variantSelects.querySelectorAll('select');
        selects.forEach((sel, idx) => {
          const pos = sel.dataset.optionPosition || (idx + 1);
          if (sel.value) {
            selected[`option${pos}`] = sel.value;
          }
        });
      }

      stickySelects.forEach(sel => {
        const pos = sel.dataset.optionPosition;
        if (pos) {
          selected[`option${pos}`] = sel.value;
        }
      });

      // "No sé la talla" no es una variante real: se ignora la talla para encontrar el precio de la piedra
      Object.keys(selected).forEach(key => {
        if (selected[key] === 'No sé la talla') delete selected[key];
      });

      return selected;
    }

    function updateStickyVariantState(variant) {
      if (!variant) return;

      if (stickyButton) {
        if (!variant.available) {
          stickyButton.disabled = true;
          stickyButton.setAttribute('title', window.variantStrings?.soldOut || 'Agotado');
          if (stickyButtonText) {
            stickyButtonText.textContent = window.variantStrings?.soldOut || 'Agotado';
          }
        } else {
          stickyButton.disabled = false;
          stickyButton.setAttribute('title', defaultButtonText);
          if (stickyButtonText) {
            stickyButtonText.textContent = defaultButtonText;
          }
        }
      }

      // Actualizar imagen si la variante tiene una específica
      if (variant.featured_image && variant.featured_image.src && stickyImage) {
        stickyImage.src = variant.featured_image.src;
      }

      // Sincronizar input de variant ID en el formulario principal
      const mainVariantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (mainVariantInput && variant.id) {
        mainVariantInput.value = variant.id;
      }

      // Actualizar precio de inmediato
      renderStickyPrice(variant);
    }

    // Inicializar detección de formato de precio y renderizar precio inicial de variante seleccionada
    if (stickyPrice && variants.length > 0) {
      const initialPriceText = stickyPrice.textContent || '';
      const selectedOpts = getFullSelectedOptions();
      const initialVariant = variants.find(v => {
        if (selectedOpts.option1 && String(v.option1).trim().toLowerCase() !== String(selectedOpts.option1).trim().toLowerCase()) return false;
        if (selectedOpts.option2 && String(v.option2).trim().toLowerCase() !== String(selectedOpts.option2).trim().toLowerCase()) return false;
        if (selectedOpts.option3 && String(v.option3).trim().toLowerCase() !== String(selectedOpts.option3).trim().toLowerCase()) return false;
        return true;
      }) || variants[0];

      if (initialVariant) {
        setupPriceDetection(initialPriceText, initialVariant.price);
        renderStickyPrice(initialVariant);
      }
    }

    function triggerMainOptionChange(optionName, optionPosition, selectedVal) {
      const variantSelects = document.querySelector('variant-selects');
      if (!variantSelects) return;

      let matchedInput = null;

      // 1. Por posición en el atributo name (ej: name="Talla-2" o "-2")
      if (optionPosition) {
        matchedInput = variantSelects.querySelector(`input[type="radio"][name$="-${optionPosition}"][value="${CSS.escape(selectedVal)}"]`);
      }

      // 2. Por prefijo del nombre de la opción
      if (!matchedInput && optionName) {
        matchedInput = variantSelects.querySelector(`input[type="radio"][name^="${CSS.escape(optionName)}-"][value="${CSS.escape(selectedVal)}"]`);
      }

      // 3. Por búsqueda en fieldsets
      if (!matchedInput) {
        const fieldsets = variantSelects.querySelectorAll('fieldset');
        for (const fs of fieldsets) {
          const legend = fs.querySelector('legend');
          const legendText = legend ? legend.textContent.toLowerCase() : '';
          if (legendText.includes(optionName.toLowerCase()) || fs.className.toLowerCase().includes(optionName.toLowerCase())) {
            matchedInput = fs.querySelector(`input[type="radio"][value="${CSS.escape(selectedVal)}"]`);
            if (matchedInput) break;
          }
        }
      }

      // 4. Cualquier radio con ese valor
      if (!matchedInput) {
        matchedInput = variantSelects.querySelector(`input[type="radio"][value="${CSS.escape(selectedVal)}"]`);
      }

      if (matchedInput) {
        if (!matchedInput.checked) {
          matchedInput.checked = true;
          matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // 5. Select dropdown en variant-selects
      let matchedSelect = variantSelects.querySelector(`select[name="options[${CSS.escape(optionName)}]"]`);
      if (!matchedSelect && optionPosition) {
        const allSelects = variantSelects.querySelectorAll('select');
        matchedSelect = allSelects[optionPosition - 1];
      }
      if (matchedSelect) {
        if (matchedSelect.value !== selectedVal) {
          matchedSelect.value = selectedVal;
          matchedSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // 3. Al cambiar una opción en el sticky cart (Talla o Piedra):
    stickySelects.forEach(select => {
      select.addEventListener('change', () => {
        const optionName = select.dataset.optionName || '';
        const optionPosition = select.dataset.optionPosition;
        const selectedVal = select.value;

        // Soporte para "No sé la talla"
        if (selectedVal === 'No sé la talla') {
          const virtualBtn = document.querySelector('.virtual-size-pill');
          if (virtualBtn) {
            virtualBtn.click();
            return;
          }
        }

        // Buscar y sincronizar en el selector de variantes principal
        triggerMainOptionChange(optionName, optionPosition, selectedVal);

        // Si tenemos datos de variantes en JSON, buscar la variante exacta considerando todas las opciones
        if (variants.length > 0) {
          const selectedOpts = getFullSelectedOptions();
          const matchedVariant = variants.find(v => {
            if (selectedOpts.option1 && String(v.option1).trim().toLowerCase() !== String(selectedOpts.option1).trim().toLowerCase()) return false;
            if (selectedOpts.option2 && String(v.option2).trim().toLowerCase() !== String(selectedOpts.option2).trim().toLowerCase()) return false;
            if (selectedOpts.option3 && String(v.option3).trim().toLowerCase() !== String(selectedOpts.option3).trim().toLowerCase()) return false;
            return true;
          });
          if (matchedVariant) {
            updateStickyVariantState(matchedVariant);
          }
        }
      });
    });

    // 4. Sincronizar desde la ficha principal hacia el sticky bar cuando el usuario cambia opciones arriba
    function syncFromMainVariantPicker() {
      const variantSelects = document.querySelector('variant-selects');
      if (!variantSelects) return;

      stickySelects.forEach(select => {
        const optionName = (select.dataset.optionName || '').toLowerCase();
        const optionPosition = select.dataset.optionPosition;
        let mainVal = null;

        if (window.isNoSeLaTallaActive && (optionName.includes('talla') || optionName.includes('tamaño') || optionName.includes('size'))) {
          mainVal = 'No sé la talla';
        }

        // Buscar radio marcado por posición
        if (!mainVal && optionPosition) {
          const checkedRadio = variantSelects.querySelector(`input[type="radio"][name$="-${optionPosition}"]:checked`);
          if (checkedRadio) mainVal = checkedRadio.value;
        }

        if (!mainVal) {
          const fieldsets = variantSelects.querySelectorAll('fieldset');
          for (const fs of fieldsets) {
            const legend = fs.querySelector('legend');
            if (legend && legend.textContent.toLowerCase().includes(optionName)) {
              const checkedRadio = fs.querySelector('input[type="radio"]:checked');
              if (checkedRadio) mainVal = checkedRadio.value;
              break;
            }
          }
        }

        if (!mainVal) {
          const allSelects = variantSelects.querySelectorAll('select');
          for (const sel of allSelects) {
            const label = sel.closest('.product-form__input')?.querySelector('label');
            if (label && label.textContent.toLowerCase().includes(optionName)) {
              mainVal = sel.value;
              break;
            }
          }
        }

        if (mainVal && select.value !== mainVal) {
          select.value = mainVal;
        }
      });

      // Sincronizar variante seleccionada y precio hacia el sticky cart
      if (variants.length > 0) {
        const selectedOpts = getFullSelectedOptions();
        const matchedVariant = variants.find(v => {
          if (selectedOpts.option1 && String(v.option1).trim().toLowerCase() !== String(selectedOpts.option1).trim().toLowerCase()) return false;
          if (selectedOpts.option2 && String(v.option2).trim().toLowerCase() !== String(selectedOpts.option2).trim().toLowerCase()) return false;
          if (selectedOpts.option3 && String(v.option3).trim().toLowerCase() !== String(selectedOpts.option3).trim().toLowerCase()) return false;
          return true;
        });
        if (matchedVariant) {
          updateStickyVariantState(matchedVariant);
        }
      } else {
        const mainPrice = document.querySelector('.product__info-container .price--large') ||
                          document.querySelector('.product__info-container .price');
        if (mainPrice && stickyPrice) {
          stickyPrice.innerHTML = mainPrice.innerHTML;
        }
      }

      const activeImg = document.querySelector('.product__media-list .is-active img, .product__media img');
      if (activeImg && stickyImage && activeImg.src) {
        stickyImage.src = activeImg.src;
      }
    }

    document.addEventListener('change', (e) => {
      if (e.target.closest('variant-selects')) {
        syncFromMainVariantPicker();
      }
    });

    // Suscribirse a eventos nativos de Dawn
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      // Evento canónico cuando Dawn termina de actualizar la variante desde el servidor
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event.data?.variant;

        if (variant) {
          updateStickyVariantState(variant);
        } else {
          // Combinación no disponible
          if (stickyButton) {
            stickyButton.disabled = true;
            stickyButton.setAttribute('title', window.variantStrings?.unavailable || 'No disponible');
          }
          if (stickyButtonText) {
            stickyButtonText.textContent = window.variantStrings?.unavailable || 'No disponible';
          }
        }
      });

      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
        syncFromMainVariantPicker();
      });

      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (stickyButton) {
          stickyButton.classList.remove('is-loading');
          stickyButton.removeAttribute('disabled');
        }
      });
    }

    // 5. Al hacer click en "Agregar al carro" en el sticky bar
    if (stickyButton) {
      stickyButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (stickyButton.disabled) return;

        stickyButton.classList.add('is-loading');

        // Estrategia 1: Clic en el botón nativo de Dawn
        const mainSubmitBtn = document.querySelector('product-form [type="submit"]');
        if (mainSubmitBtn && !mainSubmitBtn.disabled) {
          mainSubmitBtn.click();
          setTimeout(() => {
            stickyButton.classList.remove('is-loading');
          }, 1500);
          return;
        }

        // Estrategia 2: Clic en el botón de bundle si está activo
        const bundleBtn = document.querySelector('.bs-add-to-cart');
        if (bundleBtn && !bundleBtn.disabled) {
          bundleBtn.click();
          setTimeout(() => {
            stickyButton.classList.remove('is-loading');
          }, 1500);
          return;
        }

        // Estrategia 3: Enviar directamente a /cart/add.js y abrir cart-drawer
        const variantIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (variantIdInput && variantIdInput.value) {
          const isEngravingPaidInput = document.querySelector('input[data-ring-engraving-paid-hidden]');
          const engravingVariantInput = document.querySelector('input[data-ring-engraving-variant-hidden]');
          const engravingTextInput = document.querySelector('input[data-ring-engraving-hidden]');

          const hasEngravingText = engravingTextInput && engravingTextInput.value.trim().length > 0;
          const isEngravingPaid = isEngravingPaidInput && isEngravingPaidInput.value === 'true';
          const engravingVariantId = engravingVariantInput && engravingVariantInput.value;

          let fetchPromise;

          if (hasEngravingText && isEngravingPaid && engravingVariantId) {
            const ringProps = {};
            const specialSize = document.querySelector('input[name="properties[Talla Especial]"]');
            if (specialSize && specialSize.value) ringProps['Talla Especial'] = specialSize.value;
            ringProps['Grabado'] = engravingTextInput.value.trim();

            const items = [
              { id: parseInt(variantIdInput.value, 10), quantity: 1, properties: ringProps },
              { id: parseInt(engravingVariantId, 10), quantity: 1, properties: { 'Grabado': engravingTextInput.value.trim() } }
            ];

            fetchPromise = fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          } else {
            const formData = new FormData();
            formData.append('id', variantIdInput.value);
            formData.append('quantity', 1);

            const specialSize = document.querySelector('input[name="properties[Talla Especial]"]');
            if (specialSize && specialSize.value) {
              formData.append('properties[Talla Especial]', specialSize.value);
            }
            if (hasEngravingText) {
              formData.append('properties[Grabado]', engravingTextInput.value.trim());
            }

            fetchPromise = fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });
          }

          fetchPromise
          .then(r => r.json())
          .then(data => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              fetch((window.routes ? window.routes.cart_url : '/cart') + '?_=' + Date.now())
                .then(r => r.text())
                .then(html => {
                  const doc = new DOMParser().parseFromString(html, 'text/html');
                  const newSourceDrawer = doc.querySelector('cart-drawer');
                  if (newSourceDrawer) cartDrawer.classList.toggle('is-empty', newSourceDrawer.classList.contains('is-empty'));
                  const inner = document.querySelector('cart-drawer-items');
                  const newInner = doc.querySelector('cart-drawer-items');
                  if (inner && newInner) inner.replaceWith(newInner);
                  const footer = document.querySelector('.drawer__footer');
                  const newFooter = doc.querySelector('.drawer__footer');
                  if (footer && newFooter) footer.replaceWith(newFooter);
                  const bubble = doc.getElementById('cart-icon-bubble');
                  const curBubble = document.getElementById('cart-icon-bubble');
                  if (curBubble && bubble) curBubble.innerHTML = bubble.innerHTML;
                  if (typeof cartDrawer.open === 'function') cartDrawer.open();
                  else cartDrawer.classList.add('active', 'animate');
                });
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(err => console.error('Error sticky cart add:', err))
          .finally(() => {
            stickyButton.classList.remove('is-loading');
          });
        } else {
          stickyButton.classList.remove('is-loading');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCart);
  } else {
    initStickyCart();
  }
})();
